
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { protocolData } from '../data';
import { FiChevronDown, FiClipboard, FiCheck } from 'react-icons/fi';
import './ActionPlan.css';

const CodeBlock = ({ title, content }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(content);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="code-block">
            <div className="code-block-header">
                <span>{title}</span>
                <button onClick={handleCopy}>
                    {copied ? <FiCheck color="var(--green)" /> : <FiClipboard />}
                </button>
            </div>
            <pre><code>{content}</code></pre>
        </div>
    );
};

const AccordionItem = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="accordion-item">
            <motion.header
                initial={false}
                onClick={() => setIsOpen(!isOpen)}
                className="accordion-header"
            >
                {title}
                <FiChevronDown
                    style={{
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease-in-out'
                    }}
                />
            </motion.header>
            {isOpen && (
                <motion.section
                    key="content"
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                        open: { opacity: 1, height: 'auto' },
                        collapsed: { opacity: 0, height: 0 }
                    }}
                    transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
                    className="accordion-content"
                >
                    {children}
                </motion.section>
            )}
        </div>
    );
};


const ActionPlan = () => {
    const { actionPlan } = protocolData;

    return (
        <motion.section
            id="action-plan"
            className="section"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5 }}
        >
            <h2 className="section-title">{actionPlan.title}</h2>
            
            <CodeBlock 
                title={actionPlan.pinnedComment.title}
                content={actionPlan.pinnedComment.content}
            />

            <div className="accordion-container">
                 <h3 className="sub-section-title">Public Comment Reply Bank</h3>
                {actionPlan.replyBank.map((item, index) => (
                    <AccordionItem key={index} title={item.scenario}>
                        <p className="reply-text">"{item.reply}"</p>
                    </AccordionItem>
                ))}
            </div>

            <div className="protocol-section">
                <h3 className="sub-section-title">Private Communication (DM Protocol)</h3>
                <ul>
                    {actionPlan.dmProtocol.map((item, index) => (
                        <li key={index}><strong>{item.condition}:</strong> {item.action}</li>
                    ))}
                </ul>
            </div>

            <div className="protocol-section">
                <h3 className="sub-section-title">Internal Group Protocol (WhatsApp)</h3>
                <ul>
                    {actionPlan.internalProtocol.map((item, index) => (
                        <li key={index}><strong>{item.rule}:</strong> {item.description}</li>
                    ))}
                </ul>
            </div>

        </motion.section>
    );
};

export default ActionPlan;
